import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const SponsorshipMembership = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const fullNamePath = "additionalInfo.sponsor.fullName";
  const fullNameLabel =
    SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP.FULLNAME;
  const fullNameField = bindField(fullNamePath, {
    label: fullNameLabel,
    required: isFieldRequired(fullNamePath),
    onBlur: () => setPercent(initialValues),
  });

  const slmIdPath = "additionalInfo.sponsor.slmId";
  const slmIdLabel =
    SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP.AMELLIS_ID;
  const slmIdField = bindField(slmIdPath, {
    label: slmIdLabel,
    required: isFieldRequired(slmIdPath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP}-section`}
    >
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={fullNameField.path}
              label={fullNameField.label}
              required={fullNameField.required}
              disabled={fullNameField.disabled}
            >
              {(field) => (
                <Input
                  optional
                  placeholder={fullNameLabel}
                  label={fullNameLabel}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={fullNameField.defaultValue}
                  {...field}
                  onChange={fullNameField.onChange}
                  onBlur={fullNameField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={slmIdField.path}
              label={slmIdField.label}
              required={slmIdField.required}
              disabled={slmIdField.disabled}
            >
              {(field) => (
                <Input
                  optional
                  placeholder={slmIdLabel}
                  label={slmIdLabel}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={slmIdField.defaultValue}
                  {...field}
                  onChange={slmIdField.onChange}
                  onBlur={slmIdField.onBlur}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SponsorshipMembership;
